import React from "react";
import CustomText from "../components/common/general/CustomText/CustomText";
import { MotiView } from "moti";
import { useAppConfig } from "../AppConfigProvider";
import DefaultLayout from "../layouts/DefaultLayout.web";
import EnhancedAnalyticsDashboard from "../components/analyticsDashboard/EnhancedAnalyticsDashboard";

const AnalyticsDashboardView = () => {
  return (
    <DefaultLayout pageHasChat={false}>
      <MotiView
        from={{ opacity: 0, translateY: 20 }}
        animate={{ opacity: 1, translateY: 0 }}
        delay={10}
        // @ts-expect-error - transition is not typed
        transition={{ type: "timing", duration: 500 }}>
        <CustomText useTranslationText={false} textType="display" text="Dashboard" size="m" weight="ultraBold" />
      </MotiView>

      <EnhancedAnalyticsDashboard />
    </DefaultLayout>
  );
};

export default AnalyticsDashboardView;
